import { toggleBodyClass } from '../_class/_toggle';

(function () {

  if (!document.querySelector('.category-list__pulldown')) return this;

  document.querySelector('.category-list__pulldown').addEventListener('click', toggleBodyClass('pulldown-open'));

})();
